<button
  class="switcher"
  *ngIf="data?.title; else iconBtn"
  [disabled]="isDisabled"
  [icon]="$any(data?.icon)"
  [size]="size"
  [appearanceType]="data?.appearanceType ?? 'ghost'"
  [appearance]="data?.appearance ?? 'secondary'"
  [class.switcher_active_disabled]="isActive && isDisabled"
  [pseudoPressed]="isActive"
  prizmButton
>
  {{ data?.title }}
</button>

<ng-template #iconBtn>
  <button
    class="switcher switcher_icon"
    [pseudoPressed]="isActive"
    [disabled]="isDisabled"
    [icon]="$any(data?.icon)"
    [size]="size"
    [appearanceType]="data?.appearanceType ?? 'ghost'"
    [appearance]="data?.appearance ?? 'secondary'"
    prizmIconButton
  ></button>
</ng-template>
